
let autosizingField = (function() {
    let excludedTypes = [
        'checkbox',
        'radio',
        'meter',
        'progress',
    ];

    resizeAll();

    document.addEventListener('input', delegate('.autosizingfield:not(.autosizingfield-measurementfield)', (e) => resize(e.target)));
    document.addEventListener('change', delegate('.autosizingfield:not(.autosizingfield-measurementfield)', (e) => resize(e.target)));
    window.addEventListener('resize', resizeAll);

    // mutation observer
    let observer = new MutationObserver(observeMutations);
    observer.observe(document.body, {childList: true, subtree: true});

    /**
     * Resize all
     */
    function resizeAll() {
        let fields = document.querySelectorAll('.autosizingfield:not(.autosizingfield-measurementfield)');
        Array.prototype.forEach.call(fields, resize);
    }

    /**
     * Resize field
     * @param {Element} field
     */
    function resize(field) {
        let width;
        let computedStyle = getComputedStyle(field);
        field.autosizingField = field.autosizingField || {};

        switch (field.nodeName) {
            // Select
            case 'SELECT':
                let selectedIndex = field.selectedIndex > 0 ? field.selectedIndex : 0;
                let selectedOption = field.options[selectedIndex];
                let measurementField = (field.previousElementSibling && field.previousElementSibling.matches('.autosizingfield-measurementfield')) ? field.previousElementSibling : field.cloneNode();
                let measurementFieldJustAdded = false;

                measurementField.classList.add('autosizingfield-measurementfield');
                measurementField.innerHTML = '';

                let measurementOption = document.createElement('option');

                measurementOption.textContent = selectedOption.textContent;
                measurementField.appendChild(measurementOption);

                if (!document.body.contains(measurementField)) {
                    measurementFieldJustAdded = true;
                    field.parentNode.insertBefore(measurementField, field);
                }
                width = measurementField.offsetWidth;

                if (measurementFieldJustAdded) {
                    Array.from(field.attributes).forEach((attribute) => {
                        if (attribute.name == 'class') return;
                        measurementField.removeAttribute(attribute.name);
                    });
                }
            break;

            // Input
            case 'INPUT':
                if (excludedTypes.indexOf(field.type) > -1) return;

                let empty;

        		if (!field.value && field.placeholder) {
        			empty = true;
        			field.value = field.placeholder;
        		}

                // Measurement logic source: stretchy.js
                field.style.width = 0;

				switch (computedStyle.boxSizing) {
                    case 'border-box' : offset = field.offsetWidth;
                    break;

                    case 'padding-box' : offset = field.clientWidth;
                    break;

                    case 'content-box' : offset = field.minWidth;
                    break;
                }

				width = Math.max(offset, field.scrollWidth - field.clientWidth);
				field.style.width = width + 'px';

				// To bulletproof, we will set scrollLeft to a
				// huge number, and read that back to see what it was clipped to
				// and increment width by that much, iteratively
				for (var i = 0; i < 10; i ++) {
					field.scrollLeft = 1e+10;
					if (field.scrollLeft == 0) break;
					width += field.scrollLeft;
					field.style.width = width + 'px';
				}

                if (empty) {
        			field.value = '';
        		}
            break;

            // Textarea
            case 'TEXTAREA':
                field.setAttribute('rows', 1);
                let verticalPaddings = parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
                let lineHeight = parseFloat(computedStyle.lineHeight).toFixed(1);
                let scrollHeight = field.scrollHeight.toFixed(1);
                let rows = (scrollHeight <= field.clientHeight) ? 1 : Math.ceil(Number((scrollHeight - verticalPaddings) / lineHeight).toFixed(1));
                field.setAttribute('rows', rows);
            break;
        }

        if (width) {
            field.style.width = width + 'px';
        }
    }


    /**
     * Observe mutations
     * @param {Object} mutationsList
     */
    function observeMutations(mutationsList) {
        for (var mutation of mutationsList) {
            if (!mutation.addedNodes.length) continue;
            let fields = mutation.target.querySelectorAll('.autosizingfield:not(.autosizingfield-measurementfield)');
            if (!fields.length) continue;

            Array.prototype.forEach.call(fields, resize);
        }
    }
})();
